import type { Value } from "../../api.ts";
import { useTheme } from "../../glassTheme.tsx";
import { GlassCard } from "../glass/Glass.tsx";

/** The ten values as rows with their tint dot (§2 "By value"). No count beside a name — the one count in the app lives on the strip. */
export function ValueList({ values, onSelect }: { values: Value[]; onSelect: (key: string) => void }) {
  const { colors } = useTheme();
  return (
    <GlassCard padding="2px 16px">
      {values.map((v) => (
        <div
          key={v.key} onClick={() => onSelect(v.key)} role="button" tabIndex={0}
          style={{
            display: "flex", alignItems: "center", gap: 10, padding: "12px 0",
            borderBottom: `1px solid ${colors.hair}`, cursor: "pointer",
          }}
        >
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: (colors.tint as Record<string, string>)[v.key] ?? colors.hair2 }} />
          <span style={{ fontSize: 15, color: colors.ink }}>{v.name}</span>
        </div>
      ))}
    </GlassCard>
  );
}
